import data from "../../../../data/schema/shared/sharedData";

export default {
  name: "Foreign Labor Recruiter Profile",
  sections: [
    {
      name: "Type of Representation",
      fields: [
        {
          machine_name: "new_profile_fl_recr_last_name",
          widget: "text",
          label: "Last (family Name) Name",
          maxLength: 35,
          validate: ["required"],
          tooltip: "Enter the last name of the individual recruiter.",
        },
        {
          machine_name: "new_profile_fl_recr_first_name",
          widget: "text",
          label: "First (given) name",
          maxLength: 35,
          validate: ["required"],
          tooltip: "Enter the first name of the individual recruiter.",
        },
        {
          machine_name: "new_profile_fl_recr_middle_name",
          widget: "text",
          label: "Middle Name(s)",
          maxLength: 35,
          tooltip: "Enter the middle name of the individual recruiter.",
        },
        {
          machine_name: "new_profile_fl_recr_employer_name",
          widget: "text",
          label: "Name of Employer/Recruiting Organization",
          maxLength: 66,
          validate: ["required"],
          tooltip: "Enter the name of the employer/recruiting organization",
        },
      ],
    },
    {
      name: "Recruiter - Location",
      fields: [
        {
          machine_name: "new_profile_fl_recr_country_id",
          widget: "select",
          label: "Country",
          selection: data.country,
          validate: ["required"],
          clearSchema: [
            "new_profile_fl_recr_state_id",
            "new_profile_fl_recr_province",
          ],
          tooltip:
            "Enter the country of the recruiter’s principal place of business.",
        },
        {
          machine_name: "new_profile_fl_recr_state_id",
          widget: "select",
          label: "State",
          selection: data.state,
          validate: ["required"],
          isVisible: {
            when: "new_profile_fl_recr_country_id",
            is: "UNITED STATES OF AMERICA",
          },
          tooltip:
            "Enter the State, District, or Territory of the recruiter’s principal place of business.",
        },
        {
          machine_name: "new_profile_fl_recr_city",
          widget: "text",
          label: "City",
          maxLength: 35,
          validate: ["required"],
          tooltip:
            "Enter the city of the recruiter’s principal place of business.",
        },

        {
          machine_name: "new_profile_fl_recr_zip",
          widget: "text",
          label: "Postal code",
          maxLength: 10,
          validate: [
            "required",
            {
              postalCountry: "new_profile_fl_recr_country_id",
              needsFieldValues: true,
              extraData: {
                valueOf: "new_profile_fl_recr_country_id",
                allowNAs: true,
              },
            },
            {
              isRequired: "new_profile_fl_recr_country_id",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "UNITED STATES OF AMERICA",
              },
            },
          ],
          tooltip:
            "Enter the postal (zip) code of the recruiter’s principal place of business.",
        },
        {
          machine_name: "new_profile_fl_recr_province",
          widget: "text",
          label: "Province",
          maxLength: 25,
          tooltip:
            "Enter the province of the recruiter’s principal place of business, if applicable.  Enter “N/A” if not applicable.",
        },
      ],
    },
    {
      name: "For H-2A Applications Only",
      fields: [
        {
          machine_name: "new_profile_fl_recr_reg_num_1",
          label: "Registration Number 1 §",
          widget: "text",
          maxLength: 120,
          tooltip: `Enter the unique registration number issued by, or on behalf of, the governmental agency (e.g., Ministry of Labor) with jurisdiction over the country in which the person is authorized or licensed to provide domestic or international recruiting services, if applicable.  The entry in this field must be the most recent and valid registration number issued to the person by the governmental agency.  If the person is providing domestic or international recruiting services in the country that does administer a system for authorizing or licensing foreign labor recruiters <b>and such person is NOT registered or refuses to provide the unique registration number based on due diligence to obtain it by the employer</b>, enter all “9s” in this field. If the person is providing domestic or international recruiting services in a country that does not administer a system for authorizing or licensing any person or entity to conduct domestic or international recruiting services, enter “N/A.”`,
        },
        {
          machine_name: "new_profile_fl_recr_reg_num_country_1",
          widget: "select",
          label: "Issuing Country §",
          selection: data.country,
          clearSchema: [
            "new_profile_fl_recr_reg_num_2",
            "new_profile_fl_recr_reg_num_country_2",
            "new_profile_fl_recr_reg_num_3",
            "new_profile_fl_recr_reg_num_country_3",
          ],
          validate: [
            {
              valueChecker: "new_profile_fl_recr_reg_num_country_1",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                check: "ifValueExists",
                valueOf: "new_profile_fl_recr_reg_num_1",
                modal: true,
              },
            },
          ],
          tooltip: `Enter the name of the issuing country (e.g, Mexico) of the unique registration number provided in Question 10, if applicable.  If the person is providing domestic or international recruiting services in the country that does administer a system for authorizing or licensing foreign labor recruiters <b>and such person is NOT registered or refuses to provide the unique registration number based on due diligence to obtain it by the employer</b>, enter “Not Registered” in this field. If the person is providing domestic or international recruiting services in a country that does not administer a system for authorizing or licensing any person or entity to conduct domestic or international recruiting services, enter “N/A.”`,
        },
        {
          machine_name: "new_profile_fl_recr_reg_num_2",
          label: "Registration Number 2 §",
          widget: "text",
          maxLength: 120,
          isVisible: {
            when: "new_profile_fl_recr_reg_num_country_1",
            is: ["- Select -", "", null, undefined],
            operator: "!==",
          },
          tooltip: `Enter the unique registration number issued by, or on behalf of, the governmental agency (e.g., Ministry of Labor) with jurisdiction over the country in which the person is authorized or licensed to provide domestic or international recruiting services, if applicable.  The entry in this field must be the most recent and valid registration number issued to the person by the governmental agency.  If the person is providing domestic or international recruiting services in the country that does administer a system for authorizing or licensing foreign labor recruiters <b>and such person is NOT registered or refuses to provide the unique registration number based on due diligence to obtain it by the employer</b>, enter all “9s” in this field. If the person is providing domestic or international recruiting services in a country that does not administer a system for authorizing or licensing any person or entity to conduct domestic or international recruiting services, enter “N/A.”`,
        },
        {
          machine_name: "new_profile_fl_recr_reg_num_country_2",
          widget: "select",
          label: "Issuing Country §",
          selection: data.country,
          isVisible: {
            when: "new_profile_fl_recr_reg_num_country_1",
            is: ["- Select -", "", null, undefined],
            operator: "!==",
          },
          clearSchema: [
            "new_profile_fl_recr_reg_num_3",
            "new_profile_fl_recr_reg_num_country_3",
          ],
          validate: [
            {
              valueChecker: "new_profile_fl_recr_reg_num_country_2",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                check: "ifValueExists",
                valueOf: "new_profile_fl_recr_reg_num_2",
                modal: true,
              },
            },
          ],
          tooltip: `Enter the name of the issuing country (e.g, Mexico) of the unique registration number provided in Question 12, if applicable.  If the person is providing domestic or international recruiting services in the country that does administer a system for authorizing or licensing foreign labor recruiters <b>and such person is NOT registered or refuses to provide the unique registration number based on due diligence to obtain it by the employer</b>, enter “Not Registered” in this field. If the person is providing domestic or international recruiting services in a country that does not administer a system for authorizing or licensing any person or entity to conduct domestic or international recruiting services, enter “N/A.”`,
        },
        {
          machine_name: "new_profile_fl_recr_reg_num_3",
          label: "Registration Number 3 §",
          widget: "text",
          maxLength: 120,
          isVisible: {
            when: "new_profile_fl_recr_reg_num_country_2",
            is: ["- Select -", "", null, undefined],
            operator: "!==",
          },
          tooltip: `Enter the unique registration number issued by, or on behalf of, the governmental agency (e.g., Ministry of Labor) with jurisdiction over the country in which the person is authorized or licensed to provide domestic or international recruiting services, if applicable.  The entry in this field must be the most recent and valid registration number issued to the person by the governmental agency.  If the person is providing domestic or international recruiting services in the country that does administer a system for authorizing or licensing foreign labor recruiters <b>and such person is NOT registered or refuses to provide the unique registration number based on due diligence to obtain it by the employer</b>, enter all “9s” in this field. If the person is providing domestic or international recruiting services in a country that does not administer a system for authorizing or licensing any person or entity to conduct domestic or international recruiting services, enter “N/A.”`,
        },
        {
          machine_name: "new_profile_fl_recr_reg_num_country_3",
          widget: "select",
          label: "Issuing Country §",
          selection: data.country,
          isVisible: {
            when: "new_profile_fl_recr_reg_num_country_2",
            is: ["- Select -", "", null, undefined],
            operator: "!==",
          },
          validate: [
            {
              valueChecker: "new_profile_fl_recr_reg_num_country_3",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                check: "ifValueExists",
                valueOf: "new_profile_fl_recr_reg_num_3",
                modal: true,
              },
            },
          ],
          tooltip: `Enter the name of the issuing country (e.g, Mexico) of the unique registration number provided in Question 14, if applicable.  If the person is providing domestic or international recruiting services in the country that does administer a system for authorizing or licensing foreign labor recruiters <b>and such person is NOT registered or refuses to provide the unique registration number based on due diligence to obtain it by the employer</b>, enter “Not Registered” in this field. If the person is providing domestic or international recruiting services in a country that does not administer a system for authorizing or licensing any person or entity to conduct domestic or international recruiting services, enter “N/A.”`,
        },
      ],
    },
    {
      name: "Profile Name",
      coloring: "blue",
      fields: [
        {
          machine_name: "new_profile_fl_recr_profile_name",
          widget: "text",
          label: "What would you like to name this profile?",
          maxLength: 50,
          validate: ["required"],
          tooltip:
            "Enter a unique name that will allow you to identify this profile",
        },
      ],
    },
  ],
};
